import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';

export const Route = createFileRoute('/legal/terms')({
  component: TermsPage,
});

function TermsPage() {
  return (
    <>
      <Helmet>
        <title>Terms of Service — AITOS Labs LLC</title>
        <meta
          name="description"
          content="Terms of Service for AITOS Labs LLC, a Wyoming limited liability company. Governs use of aitos.app and the managed-service relationship."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://aitos.app/legal/terms" />
      </Helmet>

      <p className="text-purple-400 text-xs tracking-widest mb-4">TERMS</p>
      <h1>Terms of Service</h1>
      <p>
        <strong>Last updated:</strong> May 2026
      </p>

      <h2>Provider</h2>
      <address className="not-italic">
        AITOS Labs LLC
        <br />
        30 N Gould St Ste N
        <br />
        Sheridan, WY 82801
        <br />
        United States
        <br />
        Email: <a href="mailto:hi@aitos.app">hi@aitos.app</a>
      </address>

      <h2>Use of this website</h2>
      <p>
        By using <a href="/">aitos.app</a> you agree to use the site lawfully and not to reverse
        engineer, scrape, or otherwise abuse the service.
      </p>

      <h2>Managed services</h2>
      <p>
        Managed POD operations engagements (Audit, Operate, Build) are governed by separate master
        service and operating agreements signed between AITOS Labs LLC and the client. This website
        does not constitute an offer or contract for those services.
      </p>

      <h2>Brand portfolio</h2>
      <p>
        Brands operated by AITOS Labs LLC (including Elzary) are owned by their respective brand
        entities. AITOS operates the brand under separate operating agreements.
      </p>

      <h2>Intellectual property</h2>
      <p>
        Content on this site (excluding third-party trademarks and partner logos) is owned by AITOS
        Labs LLC.
      </p>

      <h2>Disclaimer</h2>
      <p>
        The site is provided "as is" without warranties of any kind. AITOS Labs LLC is not liable
        for any indirect or consequential damages arising from use of the site.
      </p>

      <h2>Governing law</h2>
      <p>
        These Terms are governed by the laws of the State of Wyoming, United States, without regard
        to its conflict of laws principles.
      </p>

      <h2>Contact</h2>
      <p>
        For questions about these Terms, email <a href="mailto:hi@aitos.app">hi@aitos.app</a>.
      </p>
    </>
  );
}
